import { ActionPointInfo, Controller, IActionPointInfo, Menu } from '@tencent/workbench';
import { ChartFeature } from './chart-feature';
import {
    INSERT_CHART_CONFIGS,
    COLUMN_CLUSTERED_CHART_CONFIG,
    COLUMN_STACKED_CHART_CONFIG,
    COLUMN_PERCENT_STACKED_CHART_CONFIG,
    BAR_CLUSTERED_CHART_CONFIG,
    BAR_STACKED_CHART_CONFIG,
    BAR_PERCENT_STACKED_CHART_CONFIG,
    LINE_STANDARD_CHART_CONFIG,
    LINE_STACKED_CHART_CONFIG,
    LINE_PERCENT_STACKED_CHART_CONFIG,
    LINE_STANDARD_CHART_WITH_POINT_CONFIG,
    LINE_STACKED_CHART_WITH_POINT_CONFIG,
    LINE_PERCENT_STACKED_CHART_WITH_POINT_CONFIG,
    PIE_CHART_CONFIG,
    DOUGHNUT_CHART_CONFIG,
    AREA_CHART_CONFIG,
    AREA_STACKED_CHART_CONFIG,
    AREA_PERCENT_STACKED_CHART_CONFIG,
    RADAR_CHART_CONFIG,
    RADAR_WITH_FILL_CHART_CONFIG,
    RADAR_WITH_POINT_CHART_CONFIG,
    OF_PIE_BAR_CHART_CONFIG,
    OF_PIE_CHART_CONFIG,
} from './config';

@Controller({
    menuItems: INSERT_CHART_CONFIGS,
})
export class ChartController {
    constructor(private readonly feature: ChartFeature) {}

    @Menu(COLUMN_CLUSTERED_CHART_CONFIG.id, 'onClick')
    @Menu(COLUMN_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(COLUMN_PERCENT_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(BAR_CLUSTERED_CHART_CONFIG.id, 'onClick')
    @Menu(BAR_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(BAR_PERCENT_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(LINE_STANDARD_CHART_CONFIG.id, 'onClick')
    @Menu(LINE_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(LINE_PERCENT_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(LINE_STANDARD_CHART_WITH_POINT_CONFIG.id, 'onClick')
    @Menu(LINE_STACKED_CHART_WITH_POINT_CONFIG.id, 'onClick')
    @Menu(LINE_PERCENT_STACKED_CHART_WITH_POINT_CONFIG.id, 'onClick')
    @Menu(PIE_CHART_CONFIG.id, 'onClick')
    @Menu(OF_PIE_CHART_CONFIG.id, 'onClick')
    @Menu(OF_PIE_BAR_CHART_CONFIG.id, 'onClick')
    @Menu(DOUGHNUT_CHART_CONFIG.id, 'onClick')
    @Menu(AREA_CHART_CONFIG.id, 'onClick')
    @Menu(AREA_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(AREA_PERCENT_STACKED_CHART_CONFIG.id, 'onClick')
    @Menu(RADAR_CHART_CONFIG.id, 'onClick')
    @Menu(RADAR_WITH_POINT_CHART_CONFIG.id, 'onClick')
    @Menu(RADAR_WITH_FILL_CHART_CONFIG.id, 'onClick')
    public onClick(@ActionPointInfo() info: IActionPointInfo) {
        this.feature.insertChart(info.name, info.path);
    }
}
